import script from "./ParentAbsences.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentAbsences.vue?vue&type=script&setup=true&lang=js"

import "./ParentAbsences.vue?vue&type=style&index=0&id=105d0b26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-105d0b26"]])

export default __exports__